import "./css/SigningFlow.css";
import { useParams } from "react-router-dom";
import { normalizeHtmlEntities } from "../../../api/helpers";

export default function WaiverScreen({
    flowData,
    updateFlowData,
    flowContext,
    updateFlowContext,
    next,
    back,
    loading,
    setLoading,
    error,
    setError,
}) {

    const goBack = () => {
        if (loading) return;

        setError("");

        next({
            action: "review_answers"
        });
    };

    const continueToNext = () => {
        if (loading) return;

        setError("");

        next({
            action: "continue"
        });
    };


    /*
     * ---------------------------------------------------------
     * Waiver data returned by backend
     * ---------------------------------------------------------
     */

    const waiver = flowData?.waiver;
    const waiverMode = flowData?.waiverMode;// backend is the authority to take the decision || "full";
    const signerType = flowData?.signerType ; //never default to || "adult"
    const sections = flowData?.waiverTemplate?.sections || [];
    const stateClauses = flowData?.stateClauses || [];

    const renderHtml = (html) => {
        if (!html) return "";
        return normalizeHtmlEntities(html);
    };

    /*
     * ---------------------------------------------------------
     * No waiver loaded
     * ---------------------------------------------------------
     */

    if (!waiver || !flowData?.waiverTemplate) {
        return (
                <div className={`page ${loading ? "page-loading" : ""}`}>
                
                {loading && (
                    <div className="loading-overlay">
                        Loading...
                    </div>
                )}

                {error && (
                    <div className="text-red-600 mt-2">
                        {error}
                    </div>
                )}
                
                <div className="page-content waiver-content">

                    <h2 className="waiver-title">
                        Unable to load waiver
                    </h2>

                    <p>
                        The waiver could not be loaded. Please try again.
                    </p>

                </div>

            </div>
        );
    }


    return (
        <div className={`page ${loading ? "page-loading" : ""}`}>

            {loading && (
                <div className="loading-overlay">
                    Loading...
                </div>
            )}
            
            <div className="waiver-header">
                <button
                    className="waiver-back"
                    onClick={goBack}
                    disabled={loading}
                >
                    ← Back
                </button>
            </div>

            <div className="page-content waiver-content">

                <h2 className="waiver-title">
                    {waiver.service?.name ||
                        waiver.service?.serviceName ||
                        "Participant Waiver"}
                </h2>


                {/*
                 * All sections except the last section
                 */}
                {sections.slice(0, -1).map((section, index) => (

                    <div
                        key={section._id || index}
                        className="mb-6"
                    >

                        {section.title && (
                            <h3>
                                {normalizeHtmlEntities(
                                    section.title
                                )}
                            </h3>
                        )}

                        <div
                            dangerouslySetInnerHTML={{
                                __html: renderHtml(section.content)
                            }}
                        />

                    </div>

                ))}


                {/*
                 * Governing Law
                 *
                 * MUST remain second last.
                 */}
                {stateClauses.length > 0 && (
                    <div className="mt-10">

                        <h2 className="text-xl font-semibold mb-6">
                            Governing Law
                        </h2>

                        {stateClauses.map((item, index) => (
                            <div
                                key={item._id || index}
                                className="mb-8"
                            >
                                <h3 className="font-semibold mb-2">
                                    {normalizeHtmlEntities(
                                        item.state || ""
                                    )}
                                </h3>

                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: renderHtml(item.body)
                                    }}
                                />

                            </div>

                        ))}

                    </div>
                )}


                {/*
                 * LAST waiver section MUST remain last. Shifted to next screen.
                 
                {sections.slice(-1).map((section, index) => (

                    <div
                        key={`last_${section._id || index}`}
                        className="mb-6"
                    >

                        {section.title && (
                            <h3>
                                {normalizeHtmlEntities(
                                    section.title
                                )}
                            </h3>
                        )}

                        <div
                            dangerouslySetInnerHTML={{
                                __html: renderHtml(section.content)
                            }}
                        />

                    </div>

                ))}*/}

            </div>


            <div className="page-footer">

                <button
                    className="primary-button"
                    onClick={continueToNext}
                    disabled={loading}
                >
                    Continue to Signature
                    <span className="button-arrow">›</span>
                </button>

            </div>

        </div>
    );
}